export class PasswordValidator {
  static validateAndUpdateForm(e: React.ChangeEvent<HTMLInputElement>, id: string) {
    const value = e.target.value;
    const errorBox = document.getElementById(id);
    const validation = PasswordValidator.validatePassword(value);
    if(validation.invalid) {
      errorBox.innerText = validation.error;
    } else {
      errorBox.innerText = "";
    }
  }

  static validatePassword(password) {
    if (!/[!@#$%^&*?~)(;+-]/.test(password)) {
      return {invalid: true, error: "Musi zawierać conajmniej 1 znak specjalny."};
    }
    if(!/.*\d.*/.test(password)) {
      return {invalid: true, error: "Musi zawierać conajmniej 1 liczbę."};
    }
    if(!/(?=.*[a-z])(?=.*[A-Z])/.test(password)) {
      return {invalid: true, error: "Musi zawierać conajmniej 1 mały i duży znak."};
    }
    if(password.length < 8) {
      return {invalid: true, error: "Musi być dłuższe niż 8 znaków."};
    } else if(password.length > 50) {
      return {invalid: true, error: "Musi być krótsze niż 50 znaków."};
    }
    return {invalid: false, error: ""};
  }
}